<template>
  <div
    class="list-label"
    :class="labelClasses"
    :style="labelStyle"
  >
    <slot />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { cx } from '@/helpers'

defineOptions({ name: 'ListLabel' })

const props = defineProps({
  caption: { type: Boolean, default: false },
  header: { type: Boolean, default: false },
  lines: { type: Number, default: null }
})

const labelClasses = computed(() => cx(
  props.caption && 'is-caption',
  props.header && 'is-header',
  props.lines && 'truncate-multiple-lines'
))

const labelStyle = computed(() =>
  props.lines ? { WebkitLineClamp: props.lines } : null
)
</script>

<style scoped>
@reference "#app-styles.css";

.list-label {
  @apply max-w-full;

  & + & { @apply mt-1; }

  &.is-caption {
    @apply ink-subtle text-[11px] leading-3;
  }

  &.is-header {
    @apply ink-subtle text-[12px] leading-3.5 px-lg pt-lg pb-sm;
  }
}
</style>
